(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squirting-collection-description"] && !Shopify.designMode) return;
  try {
    
  const descriptionSections = document.querySelectorAll('[data-squirting-seo-description]');

  descriptionSections.forEach((descriptionSection) => {
    if (descriptionSection.querySelector('.squirting-seo-description__recommendations')) return;

    const headings = Array.from(descriptionSection.querySelectorAll('h1, h2, h3, h4'));
    const comboHeading = headings.find((heading) => heading.textContent.trim() === 'Create Your Own Combo');

    if (!comboHeading) return;

    const recommendations = document.createElement('div');
    recommendations.className = 'squirting-seo-description__recommendations';
    comboHeading.before(recommendations);

    let currentNode = comboHeading;
    while (currentNode) {
      const nextNode = currentNode.nextSibling;
      recommendations.append(currentNode);
      currentNode = nextNode;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
